import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {ListResponse} from '../interface/response/list-response';
import {Document as DocumentInterface} from '../interface/document';


@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private readonly documentListSubject: ReplaySubject<CountedAndPaginated<DocumentInterface>>
    = new ReplaySubject<CountedAndPaginated<DocumentInterface>>(1);
  private readonly documentNotCountedListSubject: ReplaySubject<ListResponse<DocumentInterface>>
    = new ReplaySubject<ListResponse<DocumentInterface>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: object, documentId?: string): Observable<Uuid> {
    if (documentId) {
      return this.httpClient.put(`/rest/crm/document/${documentId}`, formData)
        .pipe(
          take(1)
        ) as Observable<Uuid>;
    } else {
      return this.httpClient.post('/rest/crm/document', formData)
        .pipe(
          take(1)
        ) as Observable<Uuid>;
    }
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/document?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<DocumentInterface>) => {
        this.documentListSubject.next(result);
      });
  }

  public loadNotCountedList(page: number, pageSize: number, filters: object): void {
    this.httpClient
      .get(`/rest/crm/document?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<DocumentInterface>) => {
        this.documentNotCountedListSubject.next(result);
      });
  }

  public getDocumentListSubject(): ReplaySubject<CountedAndPaginated<DocumentInterface>> {
    return this.documentListSubject;
  }

  public getDocumentNotCountedListSubject(): ReplaySubject<ListResponse<DocumentInterface>> {
    return this.documentNotCountedListSubject;
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/document/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public downloadFile(uuid: string): void {
    this.document.location.href = `/rest/crm/document/${uuid}/downloadFile`;
  }

  public get(documentId: string): Observable<DocumentInterface> {
    return this.httpClient.get(`/rest/crm/document/${documentId}`)
      .pipe(first()) as Observable<DocumentInterface>;
  }

  public deleteDocument(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/document/${uuid}`)
      .pipe(first());
  }

  public updateDocumentInformation(formData: object, documentId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/document/${documentId}/UpdateDocumentInformation`, formData)
      .pipe(first());
  }

}
